(() => {
  const currentUrl = new URL(window.location.href);
  const legacySortMap = {
    'trending-desc': 'best-selling',
    'latest-desc': 'created-descending',
    'price-asc': 'price-ascending',
    'price-desc': 'price-descending'
  };
  const legacySort = currentUrl.searchParams.get('sort');

  if (window.location.pathname === '/collections/all' && legacySortMap[legacySort] && !currentUrl.searchParams.has('sort_by')) {
    currentUrl.searchParams.delete('sort');
    currentUrl.searchParams.set('sort_by', legacySortMap[legacySort]);
    window.location.replace(currentUrl.toString());
    return;
  }

  const routesElement = document.getElementById('ShuffleRoutes');
  const routes = routesElement ? JSON.parse(routesElement.textContent) : {
    cart: '/cart',
    cartAdd: '/cart/add',
    cartChange: '/cart/change',
    checkout: '/checkout'
  };

  const withJson = (url) => url.endsWith('.js') ? url : `${url}.js`;
  const cartDrawer = () => document.querySelector('[data-cart-drawer]');
  const menuDrawer = () => document.querySelector('[data-menu-drawer]');
  const drawerOpeners = new WeakMap();
  const focusableSelector = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#039;',
      '"': '&quot;'
    })[character]);
  }

  function money(cents, currency = 'USD') {
    const symbols = { USD: '$', AUD: 'A$', CAD: 'C$', EUR: '€', GBP: '£' };
    return `${symbols[currency] || ''}${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
  }

  function cartMoney(cents) {
    return `$${(Number(cents || 0) / 100).toFixed(2)} USD`;
  }

  function sizedImage(url, width) {
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  }

  function selectProductThumbnail(thumbnail, updateUrl = false) {
    const root = thumbnail?.closest('[data-product-root]');
    const main = root?.querySelector('[data-product-main-image]');
    if (!root || !main) return;

    main.src = thumbnail.dataset.imageUrl;
    if (thumbnail.dataset.imageSrcset) main.srcset = thumbnail.dataset.imageSrcset;
    main.alt = thumbnail.dataset.imageAlt || '';
    root.querySelectorAll('[data-product-thumbnail]').forEach((item) => {
      item.classList.toggle('active', item === thumbnail);
    });

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('image', thumbnail.dataset.imageIndex);
      window.history.pushState({ image: thumbnail.dataset.imageIndex }, '', url);
    }
  }

  function syncProductImageFromUrl(root) {
    const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];
    if (!thumbnails.length) return;

    const requestedIndex = new URL(window.location.href).searchParams.get('image');
    const requestedThumbnail = requestedIndex !== null
      ? thumbnails.find((thumbnail) => thumbnail.dataset.imageIndex === requestedIndex)
      : null;
    const initialThumbnail = thumbnails.find((thumbnail) => thumbnail.dataset.imageId === root.dataset.initialImageId);
    selectProductThumbnail(requestedThumbnail || initialThumbnail || thumbnails[0]);
  }

  function syncProductImagesFromUrl() {
    document.querySelectorAll('[data-product-root]').forEach(syncProductImageFromUrl);
  }

  function drawerIsOpen(drawer) {
    return Boolean(drawer && !drawer.hidden);
  }

  function openDrawer() {
    return [cartDrawer(), menuDrawer()].find(drawerIsOpen) || null;
  }

  function focusableElements(drawer) {
    if (!drawer) return [];
    return [...drawer.querySelectorAll(focusableSelector)].filter((element) => {
      if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      if (element.tabIndex < 0) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function restoreDrawerFocus(drawer) {
    const opener = drawerOpeners.get(drawer);
    drawerOpeners.delete(drawer);
    if (!opener?.isConnected || opener.disabled || opener.closest('[hidden], [inert], [aria-hidden="true"]')) return;
    opener.focus();
  }

  function setDrawerState(drawer, open, { opener = null, restoreFocus = true } = {}) {
    if (!drawer) return;

    if (open) {
      [cartDrawer(), menuDrawer()].forEach((otherDrawer) => {
        if (otherDrawer !== drawer && drawerIsOpen(otherDrawer)) {
          setDrawerState(otherDrawer, false, { restoreFocus: false });
        }
      });

      const focusOrigin = opener || document.activeElement;
      if (focusOrigin instanceof HTMLElement && !drawer.contains(focusOrigin)) {
        drawerOpeners.set(drawer, focusOrigin);
      }
    }

    const wasOpen = drawerIsOpen(drawer);
    drawer.hidden = !open;
    const control = drawer.matches('[data-cart-drawer]') ? '[data-cart-open]' : '[data-menu-open]';
    document.querySelectorAll(control).forEach((button) => button.setAttribute('aria-expanded', String(open)));
    document.body.classList.toggle('drawer-open', Boolean(openDrawer()));

    if (open) {
      const initialFocus = drawer.querySelector('.drawer-close') || focusableElements(drawer)[0];
      if (initialFocus) initialFocus.focus();
      else {
        drawer.tabIndex = -1;
        drawer.focus();
      }
    } else if (wasOpen) {
      if (restoreFocus) restoreDrawerFocus(drawer);
      else drawerOpeners.delete(drawer);
    }
  }

  function closeDrawers() {
    const drawer = openDrawer();
    if (drawer) setDrawerState(drawer, false);
  }

  function containDrawerFocus(event) {
    const drawer = openDrawer();
    if (!drawer) return;

    const focusable = focusableElements(drawer);
    if (!focusable.length) {
      event.preventDefault();
      drawer.tabIndex = -1;
      drawer.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const activeIndex = focusable.indexOf(document.activeElement);

    if (activeIndex === -1) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && activeIndex === 0) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && activeIndex === focusable.length - 1) {
      event.preventDefault();
      first.focus();
    }
  }

  function renderCart(cart) {
    const lines = document.querySelector('[data-cart-lines]');
    const total = document.querySelector('[data-cart-total]');
    const checkout = document.querySelector('[data-cart-checkout]');
    const itemCount = cart.item_count || 0;

    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = itemCount;
      count.hidden = itemCount === 0;
    });
    document.querySelectorAll('[data-cart-open]').forEach((button) => {
      const label = button.getAttribute('aria-label');
      if (label?.startsWith('Cart,')) button.setAttribute('aria-label', `Cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
    });

    if (total) total.textContent = cartMoney(cart.total_price);
    if (checkout) {
      checkout.classList.toggle('is-disabled', itemCount === 0);
      checkout.setAttribute('aria-disabled', String(itemCount === 0));
      checkout.tabIndex = itemCount === 0 ? -1 : 0;
    }
    if (!lines) return;

    if (!cart.items?.length) {
      lines.innerHTML = '<p class="empty-cart">YOUR CART IS EMPTY.</p>';
      return;
    }

    lines.innerHTML = cart.items.map((item) => {
      const imageUrl = item.featured_image?.url || item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<small class="cart-line-variant">${escapeHtml(item.variant_title)}</small>`
        : '';
      const image = imageUrl
        ? `<img src="${escapeHtml(sizedImage(imageUrl, 144))}" width="72" height="72" loading="lazy" alt="${escapeHtml(item.product_title)}">`
        : '';

      return `<div class="cart-line" data-cart-line="${escapeHtml(item.key)}">
        ${image}
        <div class="cart-line-content">
          <div class="cart-line-details">
            <strong class="cart-line-title">${escapeHtml(item.product_title)}</strong>
            ${variant}
            <span class="cart-line-quantity">${item.quantity} Qty</span>
          </div>
          <div class="cart-line-actions">
            <button class="remove-line" type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0">REMOVE</button>
            <span class="cart-line-price">${cartMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  async function getCart() {
    const response = await fetch(withJson(routes.cart), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  async function addToCart(id, quantity = 1, opener = null) {
    const response = await fetch(withJson(routes.cartAdd), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this item');
    await getCart();
    setDrawerState(cartDrawer(), true, { opener });
  }

  async function changeCart(key, quantity) {
    const response = await fetch(withJson(routes.cartChange), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update cart');
    renderCart(result);
  }

  async function handleAdd(button, action) {
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await action();
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;

    if (target.matches('[data-cart-open]')) {
      event.preventDefault();
      setDrawerState(menuDrawer(), false, { restoreFocus: false });
      getCart().catch(() => {}).finally(() => setDrawerState(cartDrawer(), true, { opener: target }));
      return;
    }
    if (target.matches('[data-cart-close]')) {
      setDrawerState(cartDrawer(), false);
      return;
    }
    if (target.matches('[data-menu-open]')) {
      setDrawerState(cartDrawer(), false, { restoreFocus: false });
      setDrawerState(menuDrawer(), true, { opener: target });
      return;
    }
    if (target.matches('[data-menu-close]')) {
      setDrawerState(menuDrawer(), false);
      return;
    }
    if (target.matches('[data-cart-change]')) {
      changeCart(target.dataset.key, target.dataset.quantity).catch((error) => window.alert(error.message));
      return;
    }
    if (target.matches('[data-quick-add]')) {
      handleAdd(target, () => addToCart(target.dataset.variantId, 1, target));
      return;
    }
    if (target.matches('[data-product-thumbnail]')) {
      event.preventDefault();
      selectProductThumbnail(target, true);
      return;
    }
    if (target.matches('[data-variant-button]')) {
      const root = target.closest('[data-product-root]');
      root.querySelector('[data-variant-input]').value = target.dataset.variantId;
      root.querySelector('[data-product-price]').textContent = target.dataset.price;
      root.querySelectorAll('[data-variant-button]').forEach((button) => {
        const active = button === target;
        button.classList.toggle('active', active);
        button.setAttribute('aria-checked', String(active));
      });
      const addButton = root.querySelector('[data-add-to-cart]');
      const addButtonLabel = addButton.querySelector('[data-add-to-cart-label]');
      const available = target.dataset.available === 'true';
      addButton.disabled = !available;
      addButtonLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      if (target.dataset.imageId) root.querySelector(`[data-product-thumbnail][data-image-id="${target.dataset.imageId}"]`)?.click();
      return;
    }
    if (target.matches('[data-quantity-minus], [data-quantity-plus]')) {
      const input = target.closest('.quantity-block').querySelector('[data-quantity-input]');
      const delta = target.matches('[data-quantity-plus]') ? 1 : -1;
      input.value = Math.max(1, Number(input.value || 1) + delta);
      return;
    }
    if (target.matches('[data-share]')) {
      if (navigator.share) navigator.share({ title: document.title, url: window.location.href }).catch(() => {});
      else navigator.clipboard?.writeText(window.location.href);
      return;
    }
    if (target.matches('[data-cart-checkout][aria-disabled="true"]')) event.preventDefault();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]');
    const data = new FormData(form);
    const productRoot = form.closest('[data-product-root]');
    const activeVariant = form.querySelector('[data-variant-button].active');
    const variantId = data.get('id') || activeVariant?.dataset.variantId || productRoot?.dataset.initialVariantId;
    handleAdd(button, () => addToCart(variantId, data.get('quantity') || 1, button));
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-product-filter]')) return;
    const query = event.target.value.trim().toLowerCase();
    const cards = [...document.querySelectorAll('[data-product-card]')];
    let visible = 0;
    cards.forEach((card) => {
      const match = card.dataset.productTitle.includes(query);
      card.hidden = !match;
      if (match) visible += 1;
    });
    const empty = document.querySelector('[data-filter-empty]');
    if (empty) empty.hidden = visible !== 0;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openDrawer()) {
      event.preventDefault();
      closeDrawers();
    } else if (event.key === 'Tab') {
      containDrawerFocus(event);
    }
  });

  window.addEventListener('popstate', syncProductImagesFromUrl);

  syncProductImagesFromUrl();
})();
